import Vue from 'vue'
import Router from 'vue-router'

import { auth, functions } from '@/store/firebase'
import store from '@/store/index'
// functions.useFunctionsEmulator('http://localhost:5001')
// functionsSP.useFunctionsEmulator('http://localhost:5001')

const Home = () => import('./views/Home')
const Board = () => import('./views/Board')
const Decorator = () => import('./views/Decorator.vue')
const NotAuthorized = () => import('./views/NotAuthorized.vue')

function lazyLoadRoute(route) {
  return () => import(`./views/configs/${route}`)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Decorator,
      children: [
        {
          path: '/',
          name: 'Visão Geral',
          meta: {
            notAllowed: ['administrator']
          },
          component: Home
        },
        {
          path: '/billing',
          name: 'Faturamento',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Billing.vue')
        },
        {
          path: '/companies',
          name: 'Empresas',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Companies.vue')
        },
        {
          path: '/company',
          name: 'Nova empresa',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Company.vue')
        },
        {
          path: '/company/:iuid',
          name: 'Editar empresa',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Company.vue'),
          props: true
        },
        {
          path: '/customers',
          name: 'Clientes',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('Customers.vue')
        },
        {
          path: '/board',
          name: 'Oportunidades',
          meta: {
            notAllowed: ['administrator']
          },
          component: Board
        },
        {
          path: '/schedules',
          name: 'Agendamentos',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('Schedules.vue')
        },
        {
          path: '/customer/:iuid',
          name: 'Cliente',
          meta: {
            notAllowed: ['administrator']
          },
          props: true,
          component: lazyLoadRoute('Customer.vue')
        },
        {
          path: '/info/:cpf',
          name: 'Informações',
          meta: {
            notAllowed: []
          },
          props: true,
          component: lazyLoadRoute('Customer.vue')
        },
        {
          path: '/distributions',
          name: 'Distribuições',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distributions.vue')
        },
        {
          path: '/distribution',
          name: 'Nova distribuição',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distribution.vue')
        },
        {
          path: '/distribution/:iuid',
          name: 'Editar distribuição',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distribution.vue'),
          props: true
        },
        {
          path: '/goals',
          name: 'Metas',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Goals.vue')
        },
        {
          path: '/goal',
          name: 'Nova meta',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Goal.vue')
        },
        {
          path: '/goal/:iuid',
          name: 'Editar meta',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Goal.vue'),
          props: true
        },
        {
          path: '/stores',
          name: 'Lojas',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Stores.vue')
        },
        {
          path: '/store',
          name: 'Nova loja',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Store.vue')
        },
        {
          path: '/store/:iuid',
          name: 'Editar loja',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Store.vue'),
          props: true
        },
        {
          path: '/uploads',
          name: 'Uploads',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Uploads.vue')
        },
        {
          path: '/upload',
          name: 'Upload',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Upload.vue')
        },
        {
          path: '/users',
          name: 'Usuários',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Users.vue')
        },
        {
          path: '/user',
          name: 'Novo usuário',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('User.vue')
        },
        {
          path: '/user/:iuid',
          name: 'Editar usuário',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('User.vue'),
          props: true
        },
        {
          path: '/banks',
          name: 'Bancos',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Banks.vue')
        },
        {
          path: '/bank',
          name: 'Novo banco',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Bank.vue')
        },
        {
          path: '/bank/:iuid',
          name: 'Editar banco',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Bank.vue'),
          props: true
        },
        {
          path: '/campaigns',
          name: 'Campanhas',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Campaigns.vue')
        },
        {
          path: '/campaign',
          name: 'Nova campanha',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue')
        },
        {
          path: '/campaign/:iuid',
          name: 'Editar campanha',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue'),
          props: true
        },
        {
          path: '/campaign/:iuid/clone',
          name: 'Clonar campanha',
          meta: {
            notAllowed: ['administrator', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue'),
          props: true
        },
        {
          path: '/status',
          name: 'Novo Ciclo',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Status.vue')
        },
        {
          path: '/statuses',
          name: 'Status',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Statuses.vue')
        },
        {
          path: '/status/:iuid',
          name: 'Editar Status',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Status.vue'),
          props: true
        },
        {
          path: '/blacklists',
          name: 'Blacklists',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Blacklists.vue'),
          props: true
        },
        {
          path: '/blacklist/:iuid',
          name: 'Blacklist',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Blacklist.vue'),
          props: true
        },
        {
          path: '/report',
          name: 'Relatórios',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Report.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      meta: { noAuth: true },
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
      redirect: '/login/sign-in',
      children: [
        {
          path: 'sign-in',
          name: 'sign-in',
          meta: { noAuth: true },
          component: () => import('./components/login/SignIn.vue')
        },
        {
          path: 'sign-up',
          name: 'sign-up',
          meta: { noAuth: true },
          component: () => import('./components/login/SignUp.vue')
        }
      ]
    },
    {
      path: '/notAuthorized',
      name: 'Não Autorizado',
      component: NotAuthorized
    }
  ]
})

function parseJwt(token) {
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  )

  return JSON.parse(jsonPayload)
}

router.beforeEach(async(to, from, next) => {
  let currentUser = auth.currentUser

  if (currentUser) {
    const idToken = await currentUser.getIdToken()
    const decode = parseJwt(idToken)

    let user = {
      uid: currentUser.uid,
      isAnonymous: currentUser.isAnonymous,
      phoneNumber: currentUser.phoneNumber,
      photoURL: currentUser.photoURL,
      email: currentUser.email,
      companyId: decode.companyId,
      branchId: decode.branchId,
      profile: decode.profile
    }

    functions
      .httpsCallable('verifyIpAddressOnCall')()
      .catch(err => {
        console.log(err)
        auth.signOut()
        if (err.message === 'The IP address is out of range.') {
          window.alert('Voce está fora do seu horário de serviço!')
        }
        next('/login')
      })

    await store.dispatch('setUser', user)

    const { notAllowed } = to.meta

    if (notAllowed && notAllowed.includes(user.profile)) {
      next('/notAuthorized')
    }

    store.dispatch('updateScheduleCount')

    if (to.path === '/' && user.profile === 'administrator') {
      return next('/companies')
    }

    return next()
  } else if (to.meta.noAuth) {
    return next()
  } else {
    return next('/login')
  }
})

export default router
